// How the member's current account on the Member Platform was set up: the
// method of their latest sign-up, as the platform states it. It changes when
// the member signs up again another way (a referral or voucher account
// converted to SSO), and each case records the change in its history.
export enum SignUpMethod {
  // the referral link we email the member
  referral = 'referral',
  // an organization's voucher code
  voucher = 'voucher',
  // the organization's own identity provider
  sso = 'sso',
}

export function displaySignUpMethod(value: SignUpMethod) {
  switch (value) {
    case SignUpMethod.referral:
      return 'Referral';
    case SignUpMethod.voucher:
      return 'Voucher code';
    case SignUpMethod.sso:
      return 'SSO';
    default:
      throw new Error(`Unknown sign-up method: ${value}`);
  }
}

export function isSignUpMethod(value: unknown): value is SignUpMethod {
  return Object.values<unknown>(SignUpMethod).includes(value);
}
